export const uiTokens = {
  page: 'p-4 sm:p-6',
  pageWide: 'p-4 sm:p-6 max-w-7xl mx-auto',
  stack: 'space-y-4 sm:space-y-6',
  titleLg: 'text-2xl sm:text-3xl font-semibold tracking-tight text-slate-900',
  titleMd: 'text-xl sm:text-2xl font-semibold tracking-tight text-slate-900',
  subtitle: 'text-sm sm:text-base text-slate-600',
  card: 'bg-white rounded-xl sm:rounded-2xl border border-slate-200 shadow-sm',
  cardSoft: 'bg-white rounded-xl border border-slate-200 shadow-sm',
  input:
    'w-full border border-slate-300 rounded-xl px-3 py-2 sm:py-2.5 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent',
  inputCompact:
    'border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent',
  buttonPrimary:
    'px-3 sm:px-4 py-2 sm:py-2.5 text-sm bg-indigo-600 text-white rounded-xl hover:bg-indigo-700 transition-colors duration-200',
  buttonSuccess:
    'px-3 sm:px-4 py-2 sm:py-2.5 text-sm bg-green-600 text-white rounded-xl hover:bg-green-700 transition-colors duration-200',
  buttonAccent:
    'px-3 sm:px-4 py-2 sm:py-2.5 text-sm bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors duration-200',
  buttonSecondary:
    'px-3 sm:px-4 py-2 sm:py-2.5 text-sm text-slate-600 border border-slate-300 rounded-xl hover:bg-slate-50 transition-colors duration-200',
  divider: 'border-slate-200',
};

export const cx = (...parts) => parts.filter(Boolean).join(' ');
